"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable no-param-reassign */

/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var constants_1 = require("../../constants");

var styles = tslib_1.__importStar(require("./WishlistIcon.style"));

var whiteWishList = {
  filled: 'ic_wishlist_md_white_filled',
  notFilled: 'ic_wishlist_md_white_not_filled',
  hover: 'ic_wishlist_md_white_hover'
};
var grayWishList = {
  filled: 'ic_wishlist_md_gray_600_filled',
  notFilled: 'ic_wishlist_md_gray_300_not_filled',
  hover: 'ic_wishlist_md_gray_300_hover'
};

function WishlistIcon(_ref) {
  var className = _ref.className,
      isWished = _ref.isWished,
      isGray = _ref.isGray,
      onClick = _ref.onClick;

  var _react_1$useState = react_1.useState(isWished),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isWishedState = _react_1$useState2[0],
      setWished = _react_1$useState2[1];

  var wishListIconNames = isGray ? grayWishList : whiteWishList;

  function handleClick(event) {
    event.stopPropagation();
    onClick && onClick();
  }

  function handleMouseEnter(_ref2) {
    var currentTarget = _ref2.currentTarget;

    if (!isWishedState) {
      currentTarget.src = "".concat(constants_1.S3_RESOURCE_ICONS, "/").concat(wishListIconNames.hover, ".svg");
    }
  }

  function handleMouseLeave(_ref3) {
    var currentTarget = _ref3.currentTarget;

    if (!isWishedState) {
      currentTarget.src = "".concat(constants_1.S3_RESOURCE_ICONS, "/").concat(wishListIconNames.notFilled, ".svg");
    }
  }

  react_1.useEffect(function () {
    setWished(isWished);
  }, [isWished]);
  return jsx_runtime_1.jsx("img", {
    role: "button",
    className: className,
    css: styles.wrapper,
    src: "".concat(constants_1.S3_RESOURCE_ICONS, "/").concat(isWished ? wishListIconNames.filled : wishListIconNames.notFilled, ".svg"),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    alt: "wishlist heart",
    onClick: handleClick
  }, void 0);
}

exports.default = react_1.memo(WishlistIcon);